import { render, staticRenderFns } from "./AreaCreate.vue?vue&type=template&id=e7f59772&"
import script from "./AreaCreate.vue?vue&type=script&lang=js&"
export * from "./AreaCreate.vue?vue&type=script&lang=js&"
import style0 from "./AreaCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports